import React from "react";
import {
  Navbar,
  Arabian,
  Services,
  ContactUs,
  Project,
  Ai,
  DBank,
  AnimatedRoutes,
  Wallets,
} from "../components";

const Home = () => {
  return (
    <div>
      {" "}
      <div className="gradient-bg-welcome">
        <Navbar />
        <Arabian />
      </div>
      <Project />
      <Services />
      <Wallets />
      <AnimatedRoutes />
      <Ai />
      <DBank />
      <ContactUs />
    </div>
  );
};

export default Home;
